import React from "react";
import "./styles.css";

const RippleButton = ({ children, onClick, className, disable = false }) => {
  const getContrastingColor = (color, opacity = 1) => {
    // Extracting RGB values from the color string
    const rgb = color.match(/\d+/g).map(Number);
    const [r, g, b] = rgb;

    // Calculating brightness using the luminance formula
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // Using white for dark backgrounds, black for light backgrounds
    const contrastColor = brightness > 128 ? "0, 0, 0" : "255, 255, 255";
    return `rgba(${contrastColor}, ${opacity})`;
  };

  const handleClick = (e) => {
    const button = e.currentTarget;

    const ripple = document.createElement("span");
    const rect = button.getBoundingClientRect();

    const rippleX = e.clientX - rect.left;
    const rippleY = e.clientY - rect.top;

    const backgroundColor = window.getComputedStyle(button).backgroundColor;

    const rippleColor = getContrastingColor(backgroundColor, 0.2);

    ripple.className = "ripple";
    ripple.style.background = rippleColor;
    ripple.style.left = `${rippleX}px`;
    ripple.style.top = `${rippleY}px`;

    button.appendChild(ripple);

    ripple.addEventListener("animationend", () => {
      ripple.remove();
    });

    if (onClick) onClick(e);
  };

  return (
    <button disabled={disable} className={`button ${className}`} onClick={handleClick}>
      {children}
    </button>
  );
};

export default RippleButton;
